let blackList = [
    "salope",
    "salopes",
    "merde",
    "pute",
    "con",
    "cons",
    "branler",
    "sexe",
    "fuck",
    "hitler",
    "batard",
    "cul",
    "motherfucking",
    "cock",
    "ass",
    "sucker",
    "bitch",
    "PD",
    "baisé",
    "baiser",
    "baises",
    "connasse",
    "putain",
    "pouffiasse",
    "couille",
    "couilles",
    "encule",
    "gueuze",
    "merdasse",
    "crotte",
    "mortecouille",
    "pouffiasse",
    "pissoie",
    "batarde",
    "enculer",
    "bite"
];

export default blackList;